import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const packages = [{
  name: 'Discovery Sprint',
  duration: '1 Woche',
  target: 'Teams, die den ersten KI-Use-Case identifizieren wollen',
  includes: ['1 Resident Engineer', 'Use Case Workshop', 'Feasibility Assessment', 'Priorisierte Roadmap'],
  teamSize: '2–4 Personen',
  price: 'Ab 15.000 € pro Sprint',
  featured: false
}, {
  name: 'Build Sprint',
  duration: '2 Wochen',
  target: 'Teams mit definiertem Use Case, die einen funktionierenden Prototypen brauchen',
  includes: ['2 Resident Engineers', 'Dedizierter Workspace', 'GPU Cloud Credits', 'Funktionierender Prototyp + Dokumentation'],
  teamSize: '3–6 Personen',
  price: 'Ab 35.000 € pro Sprint',
  featured: true
}, {
  name: 'Transform Sprint',
  duration: '4 Wochen',
  target: 'Unternehmen, die eine KI-Abteilung aufbauen oder skalieren wollen',
  includes: ['Full Engineering Support', 'Architektur-Review', 'Team-Training', 'Production Readiness Assessment'],
  teamSize: '4–8 Personen',
  price: 'Ab 65.000 € pro Sprint',
  featured: false
}];
export function SprintPackages() {
  return <section id="pakete" className="py-24 md:py-32 bg-surface border-y border-border" data-id="element-305">
      <div className="container mx-auto px-6" data-id="element-306">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-307">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading mb-6" data-id="element-308">
            Flexibel. Bezahlbar.{' '}
            <span className="text-accent italic" data-id="element-309">Ergebnisorientiert.</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-7xl mx-auto items-center" data-id="element-310">
          {packages.map((pkg, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className={`relative bg-[#020611] p-8 md:p-10 flex flex-col h-full ${pkg.featured ? 'border border-accent shadow-[0_0_30px_rgba(0,174,239,0.1)] lg:-my-4' : 'border border-border'}`} data-id="element-311">
              {pkg.featured && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-accent text-[#020611] px-4 py-1 text-xs font-bold uppercase tracking-wider" data-id="element-312">
                  Beliebtestes Paket
                </div>}

              <div className="mb-8" data-id="element-313">
                <div className="flex justify-between items-end mb-4" data-id="element-314">
                  <h3 className="text-2xl font-heading font-semibold" data-id="element-315">
                    {pkg.name}
                  </h3>
                  <span className="text-accent font-mono text-sm" data-id="element-316">
                    {pkg.duration}
                  </span>
                </div>
                <p className="text-sm text-muted h-10" data-id="element-317">{pkg.target}</p>
              </div>

              <div className="flex-grow mb-8" data-id="element-318">
                <p className="text-xs text-muted-dark uppercase tracking-wider mb-4 font-semibold" data-id="element-319">
                  Inklusive
                </p>
                <ul className="space-y-3" data-id="element-320">
                  {pkg.includes.map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-foreground/90" data-id="element-321">
                      <Check size={16} className="text-accent shrink-0 mt-0.5" data-id="element-322" />
                      <span data-id="element-323">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="pt-8 border-t border-border mt-auto" data-id="element-324">
                <div className="flex justify-between items-center mb-6" data-id="element-325">
                  <span className="text-sm text-muted" data-id="element-326">Teamgröße:</span>
                  <span className="text-sm font-medium" data-id="element-327">{pkg.teamSize}</span>
                </div>
                <div className="text-xl font-heading font-medium text-accent mb-6" data-id="element-328">
                  {pkg.price}
                </div>
                <a href="mailto:info@pezula.net?subject=House%20Of%20AI" className={`w-full py-4 text-sm font-bold uppercase tracking-wider transition-colors text-center block ${pkg.featured ? 'bg-accent text-[#020611] hover:bg-accent-hover' : 'bg-surface border border-border text-foreground hover:border-accent hover:text-accent'}`} data-id="element-329">
                  Sprint anfragen
                </a>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-center mt-12 text-sm text-muted max-w-2xl mx-auto" data-id="element-330">
          Alle Pakete inklusive: Arbeitsplätze, Verpflegung, Community-Zugang,
          Workshop-Materialien. Exkl. Kosten für Anreise & Übernachtungen.
        </motion.div>
      </div>
    </section>;
}